@if (form) {
  <div class="row">
    <div class="col-12">
      <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
        <span class="required">*</span>
      }</p>
      <div class="d-flex">
        @for (num of listNumber; track trackByIndex($index)) {
          <button class="btn-number" [ngClass]="{'action':num.status }"
          (click)="updateValue(num)">{{num.choice_name}}</button>
        }
      </div>
      <!-- <app-validate-items [action]="form.question_required" [valid]="actionValue"
      (validUpdate)="updateValiDate($event)">
      <button *ngFor="let num of listNumber" class="btn-number" [ngClass]="{'action':num.status }"
      (click)="updateValue(num)">{{num.choice_name}}</button>
    </app-validate-items> -->
  </div>
</div>
}